import { HttpClient } from "./types";
import { createProductService } from "./productService";
import { createCategoryService } from "./categoryService";
import { createOrderService } from "./orderService";
import { createAuthService } from "./authService";
import { createPaymentService } from "./paymentService";
import { createUserClientService } from "./userClientService";
import { createShippingService } from "./shippingService";
import { createBannerService } from "./bannerService";
import { createAnalyticsService } from "./analyticsService";
import { createUserAddressService } from "./userAddressService";
import { createCouponService } from "./couponService";
import { createTiendaInfoService } from "./tiendaInfoService";

export { createAnalyticsService } from "./analyticsService";
export type { TiendaInfoDTO } from "./tiendaInfoService";
export { createContenidoPublicoService } from "./contenidoPublicoService";
export type { ContenidoVersionPublicaDTO } from "./contenidoPublicoService";

export const createAllServices = (httpClient: HttpClient) => ({
    products: createProductService(httpClient),
    categories: createCategoryService(httpClient),
    orders: createOrderService(httpClient),
    auth: createAuthService(httpClient),
    payments: createPaymentService(httpClient),
    userClients: createUserClientService(httpClient),
    shippings: createShippingService(httpClient),
    banners: createBannerService(httpClient),
    analytics: createAnalyticsService(httpClient),
    userAddresses: createUserAddressService(httpClient),
    coupons: createCouponService(httpClient),
    tiendaInfo: createTiendaInfoService(httpClient),
});
